/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「下拉选择框」
 */
<template>
  <div
    class="cDropDown-container"
    :class="{ 'cDropDown-havetext': value }"
    @click="handleSelect"
  >
    <p class="cDropDown-text">
      {{ value ? value : placeholder }}
    </p>
    <p class="cDropDown-icon"></p>
  </div>
</template>


<script>
export default {
  props: ['value', 'placeholder'],
  data() {
    return {};
  },
  methods: {
    handleSelect() {
      this.$emit('clickbtn');
    }
  }
};
</script>

<style lang="less"  scoped>
.cDropDown-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.14rem;
  box-sizing: border-box;
  border: 2px solid var(--maincolor);
  background-color: var(--bg-pinkcolor);
  border-radius: 0.05rem;
  color: #868686;
  height: 0.5rem;
  font-size: 0.16rem;
  cursor: pointer;
  .cDropDown-icon {
    border-top: 0.07rem solid #00a4b0;
    border-right: 0.07rem solid transparent;
    border-left: 0.07rem solid transparent;
    pointer-events: none;
  }
  .cDropDown-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.cDropDown-havetext {
  background-color: #fff;
  color: var(--text-blackcolor);
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cDropDown.vue